/** @jsxImportSource @emotion/react */
import { ViewerToolsWrapperStyle, ViewerToolsContainerStyle } from './ViewerStyles';
import {ViewerToolZoomIn} from './tools/ZoomIn'
import {ViewerToolZoomOut} from './tools/ZoomOut'

export const ViewerTools = () => {
  return (
    <div css={ViewerToolsWrapperStyle}>
      <ul css={ViewerToolsContainerStyle}>
        <li><ViewerToolZoomIn /></li>
        <li><ViewerToolZoomOut /></li>        
      </ul>
    </div>
  );
};

export default ViewerTools